module.exports = __webpack_public_path__ + "img/content10.19bc7cb7.png";